export const LIST_PREFERENCE_CENTERS_FAILURE =
	"LIST_PREFERENCE_CENTERS_FAILURE";
export const LIST_PREFERENCE_CENTERS_SUCCESS =
	"LIST_PREFERENCE_CENTERS_SUCCESS";
export const LIST_PREFERENCE_CENTERS_RESET = "LIST_PREFERENCE_CENTERS_RESET";
export const UPDATE_PREFERENCE_CENTER_INTERESTS_SUCCESS =
	"UPDATE_PREFERENCE_CENTER_INTERESTS_SUCCESS";
export const UPDATE_PREFERENCE_CENTER_CUSTOM_ATTRIBUTES_SUCCESS =
	"UPDATE_PREFERENCE_CENTER_CUSTOM_ATTRIBUTES_SUCCESS";
